export default __webpack_public_path__ + "media/Compass_mobile.f92d144eeda1fd8c1d9e32f1b4204a05.svg";